(() => {
  const COOKIE_NAME = 'mk_accent_mode';
  const COOKIE_MAX_AGE = 31536000;
  const DEFAULT_MODE = 'neutral';
  const VALID_MODES = new Set(['neutral', 'signal']);

  function getCookie(name) {
    const encodedPrefix = `${encodeURIComponent(name)}=`;
    const parts = document.cookie ? document.cookie.split(';') : [];

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i].trim();
      if (part.indexOf(encodedPrefix) === 0) {
        return decodeURIComponent(part.substring(encodedPrefix.length));
      }
    }

    return '';
  }

  function readMode() {
    const mode = getCookie(COOKIE_NAME);
    return VALID_MODES.has(mode) ? mode : DEFAULT_MODE;
  }

  function writeMode(mode) {
    document.cookie = `${encodeURIComponent(COOKIE_NAME)}=${encodeURIComponent(mode)}; Path=/; Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  }

  function updateToggleUI(mode) {
    const toggles = document.querySelectorAll('[data-mk-accent-toggle]');
    toggles.forEach((toggle) => {
      const isActive = toggle.dataset.mode === mode;
      toggle.classList.toggle('is-active', isActive);
      toggle.setAttribute('aria-pressed', String(isActive));
    });
  }

  function applyMode(mode, persist = false) {
    const normalizedMode = VALID_MODES.has(mode) ? mode : DEFAULT_MODE;
    document.documentElement.setAttribute('data-accent-mode', normalizedMode);
    updateToggleUI(normalizedMode);

    if (persist) writeMode(normalizedMode);
  }

  function onToggleClick(event) {
    const toggle = event.target.closest('[data-mk-accent-toggle]');
    if (!toggle) return;

    const mode = toggle.dataset.mode;
    if (!VALID_MODES.has(mode)) return;

    writeMode(mode);
    window.location.reload();
  }

  function init() {
    const mode = readMode();
    applyMode(mode, false);
    writeMode(mode);
    document.addEventListener('click', onToggleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
